import { createContext, useState } from "react";

export const DocumentContext = createContext();

export const DocumentProvider = props => {
    const [percentageUpload, setPercentageUpload] = useState(0);
    const [sectionName, setSectionName] = useState();
    return (
        <DocumentContext.Provider value={[percentageUpload, setPercentageUpload, sectionName, setSectionName]}>
            {props.children}
        </DocumentContext.Provider>
    )
}